module.exports = __webpack_public_path__ + "images/emoji/symbols.a40f56f77784ecc8eb7e.png";